import { render, staticRenderFns } from "./CustomerListItemDropdown.vue?vue&type=template&id=9f8a0696&"
import script from "./CustomerListItemDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomerListItemDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports